import { PermissionsEnum } from "@/auth/interfaces";
import { a11yProps, EstadoFactibilidadCorporativaENUM, EstadoPreventaEnum, sizeTab, useCheckPermissions } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab, Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import TablePreventaFactibilidadCorporativo from "../../shared/table_factibilidad_corporativo/TablePreventaFactibilidadCorporativo";
import TableFactibilidadCorporativo from "../../shared/table_factibilidad_corporativo/TableFactibilidadCorporativo";
import TableFactibilidadAprobada from "../../shared/table_factibilidad_corporativo/TableFactibilidadAprobada";
import InfoCoordendas from "@/shared/components/ui/InfoCoordendas/InfoCoordendas";
import TableCustomFilterPreventaFactibilidad from "../../shared/table_factibilidad_corporativo/TableCustomFilterPreventaFactibilidad";
import TableCustomFilterFactibilidad from "../../shared/table_factibilidad_corporativo/TableCustomFilterFactibilidad";
import { Assessment, Close } from "@mui/icons-material";
import TableFactibilidadTabAprobada from "../../shared/table_factibilidad_corporativo/TableFactibilidadTabAprobada";
import { useSearchParams } from "react-router-dom";

export default function FactibilidadCorporativoPage() {

  useCheckPermissions(PermissionsEnum.api_view_factibilidadcoorporativa);
  const [searchParams, setSearchParams] = useSearchParams()
  const openAuditDialog = searchParams.get('audit') === 'true'
  const [valueTab, setValueTab] = useState(0);
  //const [openAuditDialog, setOpenAuditDialog] = useState(false); 
  const handleOpenAudit = () => setSearchParams({ audit: 'true' })
  

  const handleCloseAudit = () => {
    searchParams.delete('audit');
    setSearchParams(searchParams);
    // Limpiar Zustand SOLO al cerrar el modal

  }

  useEffect(() => {
    const from = searchParams.get('from');
    if (from === 'audit') {
      setSearchParams({ audit: 'true' }, { replace: true })
    }
  }, [])

  return (
    <>
      <SingleTableBoxScene
        title={"Factibilidad Corporativa"}
        visibleReport={true}
        enableAccionBtn={true}
        labelTextActionBtn="Auditoría"
        iconActionBtn={<Assessment />}
        //fnAccionBtn={() => setOpenAuditDialog(true)}
        fnAccionBtn={handleOpenAudit}
      >
        <Box sx={{
          bgcolor: 'background.paper',
          maxWidth: sizeTab,
          paddingBottom: 2
        }} >
          <Tabs
            value={valueTab}
            onChange={(_event: React.SyntheticEvent, newValue: number) => {
              setValueTab(newValue);
            }}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            aria-label="scrollable force tabs preventa"
          >
            <Tab label={'Pre-Factibilidad'} {...a11yProps(0)} />
            <Tab label={'Pre-Factibilidades Aprobadas'} {...a11yProps(1)} />
            <Tab label={'Factibilidad'} {...a11yProps(2)} />
            <Tab label={'Factibilidad Aprobada'}{...a11yProps(3)} />
            <Tab label={'En Inspección'} {...a11yProps(4)} />
            <Tab label={'Inspeccionadas'} {...a11yProps(5)} />
            <Tab label={'Pendientes/Borradores'} {...a11yProps(6)} />
            <Tab label={'En Gestión'} {...a11yProps(7)} />
            <Tab label={'Aprobadas por NOC'} {...a11yProps(8)} />
            <Tab label={'Aprobadas por Supervisor'} {...a11yProps(9)} />
            <Tab label={'Gestión Oportunidad Comercial'} {...a11yProps(10)} />
            <Tab label={'Rechazadas'} {...a11yProps(11)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={valueTab} index={0}>
          <TablePreventaFactibilidadCorporativo
            preventa_aprobada_factibilidad={false}
            estado_preventa={`${EstadoPreventaEnum.EN_ESPERA}`}
          />
        </CustomTabPanel>

        <CustomTabPanel value={valueTab} index={1}>
          {/*
            NOTA: Este tab muestra preventas con estado PREAPROBADA.
            Aquí el vendedor debe ir a Preventa -> Oportunidades Comerciales para completar la información.
            Una vez guardada, la preventa cambia a EN_PROCESO y aparece en el Tab 2 (Factibilidad).
          */}
          <TableCustomFilterPreventaFactibilidad
            paramsFilter={{
              estado_preventa: EstadoPreventaEnum.PREAPROBADA,
            }}
          // showCustomActionBtnSpace={false}
          // enableEditing={false}
          />
        </CustomTabPanel>

        <CustomTabPanel value={valueTab} index={2}>
          {/*
          NOTA: Se usa estado_preventa_in="EN PROCESO,FINALIZADO" para que las factibilidades
          solo aparezcan aquí después de que el vendedor complete la información en Preventa.
          Esto evita que las factibilidades con preventa PREAPROBADA aparezcan antes de tiempo.
          También permite que el backup siga visible cuando la principal cambia la preventa a FINALIZADO.
        */}
          <TableFactibilidadCorporativo
            enableEditing={true}
            estado_factibilidad={EstadoFactibilidadCorporativaENUM.PENDIENTE}
            canEditGlobal={true}
            estado_preventa_in={`${EstadoPreventaEnum.EN_PROCESO},${EstadoPreventaEnum.FINALIZADO}`}
            enviado_inventario_factibilidad={false}
          />
        </CustomTabPanel>
        <CustomTabPanel value={valueTab} index={3}>
          <TableFactibilidadTabAprobada />
        </CustomTabPanel>
        {/* <CustomTabPanel value={valueTab} index={1}>
        <TablePreventaFactibilidadCorporativo 
          estado_preventa={`${EstadoPreventaEnum.PREAPROBADA}`}
          preventa_aprobada_factibilidad={false}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={2}>
        <TablePreventaFactibilidadCorporativo 
          estado_preventa={EstadoPreventaEnum.PREAPROBADA}
          preventa_aprobada_factibilidad={true}
        />
      </CustomTabPanel> */}

        <CustomTabPanel value={valueTab} index={4}>
          <TableFactibilidadCorporativo
            enableEditing={true}
            estado_factibilidad={EstadoFactibilidadCorporativaENUM.EN_INSPECCION}
            // aceptado_factibilidad={true}
            canEditGlobal={true}
          />
        </CustomTabPanel>

        <CustomTabPanel value={valueTab} index={5}>
          <TableFactibilidadCorporativo
            enableEditing={true}
            estado_factibilidad={EstadoFactibilidadCorporativaENUM.INSPECCIONADO}
            canEditGlobal={true}
          />
        </CustomTabPanel>

        <CustomTabPanel value={valueTab} index={6}>
          <TableFactibilidadCorporativo
            enableEditing={true}
            estado_factibilidad={EstadoFactibilidadCorporativaENUM.PENDIENTE}
            aceptado_factibilidad={undefined}
            canEditGlobal={true}
            preaprobado_inventario={false}
          />
        </CustomTabPanel>

        <CustomTabPanel value={valueTab} index={7}>
          <TableFactibilidadCorporativo
            enableEditing={true}
            estado_factibilidad={EstadoFactibilidadCorporativaENUM.EN_GESTION}
            aceptado_factibilidad={true}
            canEditGlobal={true}
          />
        </CustomTabPanel>


        <CustomTabPanel value={valueTab} index={8}>
          <TableCustomFilterFactibilidad
            paramsFilter={{
              aceptado_factibilidad: true
            }}
          // showCustomActionBtnSpace={false}
          // enableEditing={false}
          />
        </CustomTabPanel>


        <CustomTabPanel value={valueTab} index={9}>
          <TableFactibilidadCorporativo
            enableEditing={true}
            estado_factibilidad={EstadoFactibilidadCorporativaENUM.APROBADO}
            aceptado_factibilidad={true}
            canEditGlobal={true}
          />
        </CustomTabPanel>

        <CustomTabPanel value={valueTab} index={10}>
          <TableFactibilidadCorporativo
            enableEditing={true}
            estado_factibilidad={EstadoFactibilidadCorporativaENUM.PRE_RECHAZADO}
            aceptado_factibilidad={undefined}
            canEditGlobal={true}
          />
        </CustomTabPanel>
        <CustomTabPanel value={valueTab} index={11}>
          <TableFactibilidadCorporativo
            enableEditing={true}
            estado_factibilidad={EstadoFactibilidadCorporativaENUM.CANCELADO}
            aceptado_factibilidad={undefined}
            canEditGlobal={true}
          />
        </CustomTabPanel>
        <InfoCoordendas />


      </SingleTableBoxScene>

      {/* Dialog para Auditoría de Factibilidad */}
      <Dialog
        open={openAuditDialog}
        onClose={handleCloseAudit}
        maxWidth="xl"
        fullWidth
        PaperProps={{
          sx: { minHeight: '80vh' }
        }}
      >
        <DialogTitle sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          bgcolor: 'primary.main',
          color: 'white'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Assessment />
            Auditoría de Factibilidad Corporativa
          </Box>
          {/* <IconButton onClick={() => setOpenAuditDialog(false)} sx={{ color: 'white' }}>
            <Close />
          </IconButton> */}
          <IconButton onClick={handleCloseAudit} >
            <Close sx={{ color: 'white' }} />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 2, mt: 1 }}>
          <TableFactibilidadAprobada />
        </DialogContent>
      </Dialog>
    </>

  );

}
